module.exports = __webpack_public_path__ + "img/karpicko2019_gracze.677e99bc.jpg";